import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { MeResponse } from '@tex/finance-shared'
import { ApiError, apiGet } from './api'
import { authClient } from './auth-client'

export const ME_KEY = ['me'] as const

/** Resolves to `null` when there is no session. */
export async function fetchMe(): Promise<MeResponse | null> {
  try {
    return await apiGet<MeResponse>('/api/v1/me')
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) return null
    throw err
  }
}

/** `data === null` means "checked, not signed in"; `undefined` means still loading. */
export function useMe() {
  return useQuery({ queryKey: ME_KEY, queryFn: fetchMe, retry: false, staleTime: 60_000 })
}

export function useSignOut() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      await authClient.signOut()
    },
    onSettled: () => qc.clear(),
  })
}

export function isTexStaff(me: MeResponse | null | undefined): boolean {
  return me?.tex_role !== null && me?.tex_role !== undefined
}
